import Image from 'next/image'
import { Typography } from '@/ui/atoms/typography/Typography'
import { GradientBadge } from '@/ui/atoms/badge/Badge'
import { useUserPoints } from '@/features/points/logic/seasonMew/useUserPoints'
import { ImageDownloadDialog } from './ImageDownloadDialog'
import {
  calculateSpotsToNextBadge,
  positionToRank,
  rankToBadgeUrl,
  rankToTitle,
  spotsToNextBadgeText,
} from '@/features/points/utils/rank'

export function Rank() {
  const { data: userPoints } = useUserPoints()

  const userRank = userPoints?.rank ?? 0

  const rank = positionToRank(userRank)
  const spotsToNext = calculateSpotsToNextBadge(userRank)

  return (
    <div className="flex h-full flex-col justify-center p-12 pt-4">
      {userRank !== 0 && (
        <>
          <Image src={rankToBadgeUrl(rank)} alt={rankToTitle[rank]} width={69} height={65} />

          <div className="mt-1 flex items-center gap-2">
            <GradientBadge>
              <Typography variant="p" className="text-xs" gradient>
                {rankToTitle[rank]}
              </Typography>
            </GradientBadge>
          </div>
        </>
      )}

      <div className="mt-4 mb-3 flex flex-col items-start">
        <Typography variant="p" className="font-bold text-xl" gradient>
          Your rank
        </Typography>
        <div className="flex items-center gap-4">
          <Typography variant="p" className="font-semibold text-4xl" gradient>
            {userRank === 0 ? 'Unranked' : `#${userRank}`}
          </Typography>

          {!!userPoints?.total_amount && !!userRank && (
            <ImageDownloadDialog points={userPoints.total_amount} rank={userRank} />
          )}
        </div>
      </div>

      <Typography variant="prompt" className="text-base">
        {spotsToNextBadgeText(spotsToNext, userRank === 0)}
      </Typography>
    </div>
  )
}
